import { Pipe, PipeTransform } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { fiCustomerPaymentStatusName } from '../customer-billing-customer/customer-payment-status';

@Pipe({
    name: 'fiCustomerPaymentStatusName',
    standalone: false,
})
export class CustomerPaymentStatusNamePipe implements PipeTransform {
    constructor(private appText: AppTextService) {}

    transform(value: any, args?: any): any {
        return fiCustomerPaymentStatusName(value, this.appText);
    }
}
